import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  TASK_COUNT_CONFIG,
  TaskCountConfig,
  TaskCounts,
} from '@lyceo/shared/task-count/util';

@Injectable({
  providedIn: 'root',
})
export class TaskCountService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly taskCountConfig: TaskCountConfig =
    inject<TaskCountConfig>(TASK_COUNT_CONFIG);

  public getTaskCounts(homiPersonId: string): Observable<TaskCounts> {
    const url: string = `${this.taskCountConfig.homiApiUrl}/api/pupils/${homiPersonId}/tasks-counts`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<TaskCounts>(url, { headers: headersToSend });
  }
}
